import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse, ICompany, paginate  } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'recruitmentWithdrawalCategorys'

const filter = (axios: IFactoryFunctionRequest<paginate<Array<Pick<ICompany, '_id' | 'display'>>>, undefined>) => (options = {}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: options,
  })
}

const getAll = (axios: IFactoryFunctionRequest) => ({ firmId }: { firmId?: string }): IFactoryResponse<Array<unknown>> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/all/filter`,
  })
}

const create = (axios: IFactoryFunctionRequest<any, any>) => ({ display }) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data: { display },
  })
}

const update = (axios: IFactoryFunctionRequest<any, any>) => (id, { data }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
  })
}

const deleteOne = (axios: IFactoryFunctionRequest<any, any>) => (id) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/delete/${id}`,
  })
}
// const addOne = (axios: IFactoryFunctionRequest) => (trainer:  Omit<ITrainingTrainer, '_id'>): IFactoryResponse<ITrainingTrainer> => {
//     return axios({
//         method: EMethod.post,
//         url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
//         data: trainer
//     })
// }

export default (axios: AxiosInstance) => ({
  getAll: getAll(useAxios(axios)),
  filter: filter(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
  deleteOne: deleteOne(useAxios(axios)),
  // addOne: addOne(useAxios(axios))
})
